import React, { useContext, useEffect } from "react";
import { Box, Button, Grid, makeStyles, Typography } from "@material-ui/core";
import CreateGuest from "cross-domain-storage/guest";
import { useState } from "react";
import awsconfig from "../../aws-exports";
import Amplify from "@aws-amplify/core";
import { withRouter } from "react-router-dom";
import LoadingScreen from "../../Shared/LoadingScreen";
import { useHistory } from "react-router-dom";
import { AuthContext } from "../../Context/Auth";
import { Instance } from "../../Context/axiosContext";
Amplify.configure(awsconfig);

const useStyles = makeStyles({
  img: {
    width: "100%",
    height: "100vh",
    backgroundSize: "cover",
  },

  button: {
    width: "50%",
    marginTop: "30px",
    backgroundColor: "#5555b2",
    color: "white",
    fontWeight: "500",
    height: "50px",
  },

  adminCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  para: {
    fontWeight: "lighter",
    fontSize: "22px",
  },
  textBox: {
    textAlign: "center",
    fontSize: "40px",
    height: "30vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});

const host = window.location.host.includes("local")
  ? "http://localhost:3001"
  : process.env.REACT_APP_HOST_PATH;

const SuperAdminLogin = () => {
  const history = useHistory();
  const classes = useStyles();
  const { login } = useContext(AuthContext);
  const [newLocation, setNewLocation] = useState([]);
  const [userName, setuserName] = useState("");
  const [loading, setLoading] = useState(false);

  let dummyName = newLocation[3];
  let restaurantName = dummyName && dummyName.replace(/-/g, " ");
  let loggedRestName = localStorage.getItem("rest_name") || null;

  const updateCredetails = async () => {
    const bazStorage = CreateGuest(host);
    let clientId = process.env.REACT_APP_USER_POOL_CLIENT;
    localStorage.clear();
    let promise = new Promise((resolve, reject) => {
      bazStorage.get("sharedStorage", async function (err, value) {
        if (err) {
          reject("Err occured while sharing credetails--" + err);
          return;
        }
        let keyArr = [
          `apikey`,
          `restName`,
          `mode`,
          `amplify-signin-with-hostedUI`,
          `CognitoIdentityServiceProvider.${clientId}.${userName}.idToken`,
          `CognitoIdentityServiceProvider.${clientId}.LastAuthUser`,
          `CognitoIdentityServiceProvider.${clientId}.${userName}.clockDrift`,
          `CognitoIdentityServiceProvider.${clientId}.${userName}.accessToken`,
          `CognitoIdentityServiceProvider.${clientId}.${userName}.userData`,
          `CognitoIdentityServiceProvider.${clientId}.${userName}.refreshToken`,
        ];
        let valueArr = JSON.parse(value);
        login(valueArr[4]);
        keyArr.forEach((item, index) => {
          localStorage.setItem(item, valueArr[index]);
        });
        resolve("successfull");
      });
    });
    await promise.then(() => {}).catch((err) => console.log(err));
    history.replace("/");
    setLoading(false);
  };

  useEffect(() => {
    const pathLocationClone = window.location.pathname;
    const newLocationClone = pathLocationClone.split("/");
    if (newLocationClone.length < 4) {
      history.replace("/");
      return;
    }
    setNewLocation(newLocationClone);
    setuserName(newLocationClone[2]);
  }, []);

  const adminLoginHandler = async () => {
    setLoading(true);
    await updateCredetails();
    return;
  };

  return (
    <>
      <Grid container>
        <Grid item sm={12} xs={12} md={6} lg={6}>
          <Typography className={classes.textBox}>Super Admin Mode</Typography>
          <Typography variant="h5"> </Typography>
          {loggedRestName && (
            <div className={classes.adminCol}>
              <Typography className={classes.para}>
                Already logged in with <a href="/"> '{loggedRestName}'</a>.
              </Typography>
            </div>
          )}
          <div className={classes.adminCol}>
            <Typography className={classes.para}>
              {loggedRestName
                ? `Do you want to continue with ${restaurantName}.`
                : restaurantName}
            </Typography>
            <Button
              className={classes.button}
              variant="contained"
              color="primary"
              type="submit"
              onClick={adminLoginHandler}
            >
              Continue
            </Button>
          </div>
        </Grid>
        <Grid item lg={6} md={6}>
          <Box display={{ xs: "none", md: "block", lg: "block" }}>
            <img
              className={classes.img}
              src="https://images.unsplash.com/photo-1616277434251-0e5188ccbe00?ixid=MXwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwyfHx8ZW58MHx8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
              alt="images"
            />
          </Box>
        </Grid>
      </Grid>
      {loading && <LoadingScreen loading={loading} loaderColor="secondary" />}
    </>
  );
};

export default withRouter(SuperAdminLogin);
